import { useCallback, useRef } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { LiveGiftsAnimations } from '../../../types/lives/animations'

const LIVE_GIFTS_ANIMATIONS = '/LIVE-GIFTS-ANIMATIONS'
// o backend manda 1 notificação por destinatário; agregamos a leva num update
// só → o middle mostra o TOTAL de uma vez (não fica somando 1 a 1 na tela).
const BATCH_MS = 400

export function useUpdateQuantityGift() {
  const liveId = useGlobalStore(useShallow((state) => state.liveId))

  // buffer da leva atual
  const batch = useRef<{
    msg: LiveGiftsAnimations['message'] | null
    qty: number
    names: Set<string>
    timer: ReturnType<typeof setTimeout> | null
  }>({ msg: null, qty: 0, names: new Set(), timer: null })

  const flush = useCallback(() => {
    const b = batch.current
    batch.current = { msg: null, qty: 0, names: new Set(), timer: null }
    if (!b.msg) return

    const list = Object.assign(
      {},
      useGlobalStore.getState().notifyGiftSentQuantityList,
    )
    const giftName = b.msg?.gift?.name
    const id = `${b.msg?.userSentId}-${giftName}`
    // 1 destinatário -> nome; vários -> "N pessoas" (evita lista longa)
    const validNames = [...b.names].filter(Boolean)
    const userReceived =
      validNames.length > 1
        ? `${validNames.length} pessoas`
        : (validNames[0] ?? '')

    if (list[id]) {
      // envio novo do mesmo presente → acumula o total (8 -> 16)
      list[id] = {
        ...list[id],
        quantity: (list[id].quantity ?? 0) + b.qty,
        userReceived: userReceived || list[id].userReceived,
      }
    } else {
      list[id] = { ...b.msg, id, quantity: b.qty, userReceived }
    }

    useGlobalStore.setState({ notifyGiftSentQuantityList: list })
  }, [])

  const updateQuantityGift = useCallback(
    ({ message }: LiveGiftsAnimations) => {
      try {
        const b = batch.current
        b.msg = message // último ganha (gift, remetente)
        b.qty += message?.quantity ?? 0 // soma as quantidades da leva
        String(message?.userReceived ?? '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
          .forEach((n) => b.names.add(n))
        if (b.timer) clearTimeout(b.timer)
        b.timer = setTimeout(flush, BATCH_MS)
      } catch (error) {
        console.error(error)
      }
    },
    [flush],
  )

  useSub<LiveGiftsAnimations>({
    endpoint: `${LIVE_GIFTS_ANIMATIONS}/${liveId}`,
    skip: !liveId,
    onData: updateQuantityGift,
  })
}
